import { IApiResponse } from "../interfaces/common";
import {
  ISupplierCreateAndDetailResponse,
  ISupplierParams,
  ISupplierRequest,
  ISuppliersResponse,
  UpdateSupplierStatusPayload,
  UpdateSupplierStatusResponse,
} from "../interfaces/supplier";
import authBaseAxios from "../utils/api";
import qs from "qs";

export const SupplierServices = {
  getAll: (params?: ISupplierParams): Promise<ISuppliersResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`suppliers?${queryString}`);
  },

  createSupplier: (body: ISupplierRequest): Promise<ISupplierCreateAndDetailResponse> => {
    return authBaseAxios.post("suppliers", body);
  },

  getDefaultTermsRule: () => {
    return authBaseAxios.get("/suppliers/default-term-rules-add");
  },

  getCustomizeView: (): Promise<any> => {
    return authBaseAxios.get("suppliers/customize-view");
  },

  updateCustomizeView: (data: any): Promise<any> => {
    return authBaseAxios.post("suppliers/customize-view", data);
  },

  updateStatus: (body: UpdateSupplierStatusPayload): Promise<IApiResponse<UpdateSupplierStatusResponse>> => {
    return authBaseAxios.post(`suppliers/change-status`, body);
  },

  getSuppliersByName: (params?: any): Promise<any> => {
    return authBaseAxios.get("/suppliers/dropdown", params);
  },

  getSupplierDetail: (id: string): Promise<void> => {
    return authBaseAxios.get(`suppliers/${id}`);
  },

  updateSupplier: (id: string, body: ISupplierRequest): Promise<ISupplierCreateAndDetailResponse> => {
    return authBaseAxios.put(`suppliers/${id}`, body);
  },

  getListUserBaseRole: () => {
    return authBaseAxios.get("/suppliers/users");
  },
};
